/* eslint-disable */
export default {
  _AwesomeSound: 'AwesomeSound',
  _CorrectSound: 'CorrectSound',
  _GotItSound: 'GotItSound',
  _GroovySound: 'GroovySound',
  _HowManySound: 'HowManySound',
  _InstSound: 'InstSound',
  _LessThanSound: 'LessThanSound',
  _MarbleDropInstructions: 'MarbleDropInstructions',
  _MarbleDropInstructionsDrop: 'MarbleDropInstructionsDrop',
  _MarbleDropTitle: 'MarbleDropTitle',
  _marblemath: 'marblemath',
  _MoreThanSound: 'MoreThanSound',
  _NextLevelSound: 'NextLevelSound',
  _PlusSound: 'PlusSound',
  _RadicalSound: 'RadicalSound',
  _Results: 'Results',
  _RoundSelectSound: 'RoundSelectSound',
  _Sound0: 'Sound0',
  _Sound1: 'Sound1',
  _Sound10: 'Sound10',
  _Sound11: 'Sound11',
  _Sound12: 'Sound12',
  _Sound13: 'Sound13',
  _Sound14: 'Sound14',
  _Sound15: 'Sound15',
  _Sound16: 'Sound16',
  _Sound17: 'Sound17',
  _Sound18: 'Sound18',
  _Sound19: 'Sound19',
  _Sound2: 'Sound2',
  _Sound20: 'Sound20',
  _Sound21: 'Sound21',
  _Sound22: 'Sound22',
  _Sound23: 'Sound23',
  _Sound24: 'Sound24',
  _Sound25: 'Sound25',
  _Sound3: 'Sound3',
  _Sound4: 'Sound4',
  _Sound5: 'Sound5',
  _Sound6: 'Sound6',
  _Sound7: 'Sound7',
  _Sound8: 'Sound8',
  _Sound9: 'Sound9',
  _SweetSound: 'SweetSound',
  _TooLittleSound: 'TooLittleSound',
  _TooMuchSound: 'TooMuchSound',
  _TryAgainSound: 'TryAgainSound',
}